import { render, staticRenderFns } from "./GiphyPreview.vue?vue&type=template&id=132a9476&"
import script from "./GiphyPreview.vue?vue&type=script&lang=js&"
export * from "./GiphyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports